<template>
<Navbar />
<Header v-bind:title="$t('_title_links')" />

<section v-if="links.length">
    <div class="container">
        <div v-for="link in links" :key="link.id" class="item">

            <div class="item-img" v-html="link.picture"/>
            <div class="item-content">
                <h2> {{ showText(link.title, link.title_en) }}</h2>
                <a v-bind:href="link.url" class="btn-link btn-info" target="_blank">
                    LINK HERE <font-awesome-icon icon="fa fa-angle-double-right" />
                </a>
            </div>
            <hr />
        </div>
    </div>
</section>
<section class="content-section" v-else>
    <Loader />
</section>

<Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/Loader.vue";

import showText from "@/mixin/showText.js";

export default {
  name: "App",
  components: { Navbar, Header, Footer, Loader },
  mixins: [showText],

  data() {
    return {
      title: "常用連結",
      links: []
    };
  },

  mounted() {
    fetch('https://oir.nccu.edu.tw/codeigniter/api/links')
        .then((respond) => respond.json())
        .then((data) => {
            this.links = data
            this.links.forEach(link => {
                link.picture = link.picture.match(/(<img([^>]+)>)/ig);
            });
        })
        .catch((err) => console.log(err.message))
    }
}
</script>
<style>
.item-img img{
    max-width: 95%;
    display:block;
    margin:auto;
}
</style>

<style scoped>
section{
    width: 80%;
    max-width: 1024px;
    margin: 12px auto;
    padding: 10px 50px;
    background-color: whitesmoke;
}

.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  row-gap: 24px;
}

.item {
  width: 33%;
  margin: 10px auto;
}

.item-img{
  min-height: 230px;
  align-self: center;
}

.item-content h2 {
    display: block;
    font-size: 22px;
    margin: 8px 0 ;
    font-weight: 500;
    line-height: 1.2;
    text-align: center;
}

.btn-info {
    color: #fff;
    background-color: var(--blue);
    border-color: var(--blue);
}

.btn-info:hover {
    background-color: #5bc0de;
    border-color: #5bc0de;
}

.btn-link {
    display: block;
    text-align: center;
    cursor: pointer;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: 12px 16px;
    font-size: 18px;
    border-radius: 4px;
    font-weight: 400;
    margin: 16px auto;
    text-decoration: none;
    max-width: 240px;
}

@media screen and (max-width: 992px) {
    .item {
        width: 100%;
    }
}

</style>